import React from 'react';

import ProjectSelector from './ProjectSelector';

interface HeaderProps {
  title: string;
}

const Header: React.FC<HeaderProps> = ({ title }) => {
  return (
    <header className="bg-surface-dark border-b border-slate-800 px-6 py-4">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-3">
          <h1 className="text-2xl font-bold text-white">{title}</h1>
          <span className="w-2 h-2 bg-green-500 rounded-full animate-pulse"></span>
        </div>

        <p className="text-sm text-slate-400 hidden md:block">
          QA Automation Platform
        </p>

        <div className="flex items-center gap-3">
          {/* Project Selector */}
          <ProjectSelector />
        </div>
      </div>
    </header>
  );
};

export default Header;
